import { AxiosInstance } from '../../../utilities/requestClient';
import type { EmirOverviewPageModel } from './types';

export const EMIR_BREAKDOWN_PATH = 'get_EMIR_breakdown';
export const EMIR_EXPORT_PATH = 'get_EMIR_export';

export const getEmirBreakdownURL = (positionDate?: string) =>
  positionDate
    ? `${EMIR_BREAKDOWN_PATH}/${positionDate}`
    : EMIR_BREAKDOWN_PATH;

export const getEmirExportURL = (positionDate: string) =>
  `${EMIR_EXPORT_PATH}/${positionDate}`;

export const getEmirExportFileName = (positionDate: string) =>
  `EMIR_export-${positionDate}.xlsx`;

export const appendEmirExportQueryParams = (
  url: string,
  raptorPlatformId?: string,
) => {
  if (!raptorPlatformId) {
    return url;
  }
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}raptor_platform_id=${raptorPlatformId}`;
};

export const getEmirExportDownloadUrl = (
  positionDate: string,
  raptorPlatformId?: string,
) => appendEmirExportQueryParams(getEmirExportURL(positionDate), raptorPlatformId);

/** GET /get_EMIR_breakdown — manco EMIR overview (`OverviewPage` envelope). */
export const getEmirBreakdown = async (
  positionDate?: string,
): Promise<EmirOverviewPageModel> => {
  const { data } = await AxiosInstance.get<EmirOverviewPageModel>(
    `/${getEmirBreakdownURL(positionDate)}`,
  );
  return data;
};
